import { useEffect, useState } from 'react';
import axios from 'axios';

import { getBookingInfo, TBookingInfoResponse } from '@/api/payService';
import { TBookingAgreementData } from '../types';

export default function useBookingData() {
  const [bookingToken, setBookingToken] = useState<string>();
  const [bookingInfo, setBookingInfo] = useState<TBookingInfoResponse>();
  const [bookingAgreementData, setBookingAgreementData] =
    useState<TBookingAgreementData>();
  const [bookingInfoError, setBookingInfoError] = useState<string>();

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('hash');
    if (!token) {
      return;
    }
    setBookingToken(token);

    const fetchData = async () => {
      try {
        const { data } = await getBookingInfo(token);
        setBookingInfo(data);

        const { data: html } = await axios.get<string>(data.contract_html_url);
        setBookingAgreementData({
          html,
        });
      } catch (error: any) {
        setBookingInfoError(error?.response?.data?.detail);
      }
    };
    fetchData();
  }, []);

  return {
    bookingToken,
    bookingInfo,
    bookingAgreementData,
    bookingInfoError,
  };
}
